import { createReducer } from 'utils'
import { fromJS } from 'immutable'
import { constants } from 'common/actions/user'

export const initialState = fromJS({
  isLoaded: true,
  isSubmitting: false,
  error: null,
  isAddingEmail: false
})

export default createReducer(initialState, {
  [constants.MANAGE_TRUSTED_USERS_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.MANAGE_TRUSTED_USERS_REQUEST.SUCCESS]: () => initialState,
  [constants.MANAGE_TRUSTED_USERS_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  },
  [constants.ADD_TRUSTED_USER_REQUEST.START]: state => state.set('isAddingEmail', true),
  [constants.ADD_TRUSTED_USER_REQUEST.SUCCESS]: () => initialState,
  [constants.ADD_TRUSTED_USER_REQUEST.FAILURE]: state => state.set('isAddingEmail', false)
})
